import React from "react";
import { Box, CircularProgress } from "@mui/material";

export default function CircularIndeterminate() {
  return (
    <Box sx={{ display: "flex", "& > * + *": { marginLeft: 2 } }}>
      <CircularProgress />
    </Box>
  );
}
